import { useContext } from "react";
import { MenuContext } from "@/providers/MenuProvider";

export const useMenu = () => {
  const { open, handleToggleMenu } = useContext(MenuContext);

  return {
    open,
    handleToggleMenu,
  };
};
